module.exports = __webpack_public_path__ + "img/ENE.da471bfa.svg";